import React, { useMemo } from 'react';
import { getAvatarUrl } from '../utils/avatarUtils';
import { environment } from '../config/environment';

interface PlayerCardProps {
  player: {
    id: string;
    name: string;
    score: number;
  };
}

/**
 * Memoized player card component for lobby display
 * Only re-renders when player data actually changes
 */
const PlayerCard: React.FC<PlayerCardProps> = ({ player }) => {
  // Memoize avatar URL calculation - only recalculates if player.name changes
  const avatarUrl = useMemo(
    () => getAvatarUrl(player.name, 48, environment.api.avatar),
    [player.name]
  );

  return (
    <div className="bg-gray-100 rounded-lg p-3 flex items-center gap-2">
      <img
        src={avatarUrl}
        alt={`${player.name}'s avatar`}
        className="w-8 h-8 rounded-full border-2 border-gray-300"
      />
      <span className="font-medium text-gray-700 flex-1 text-center">{player.name}</span>
    </div>
  );
};

// Memoize the component to prevent re-renders when props haven't changed
export default React.memo(PlayerCard);
